import React, { useRef, useEffect } from 'react';
import { Box } from '@material-ui/core';
import * as echarts from 'echarts';

export default ({ height, data = [] }) => {
  const pieOneRef = useRef(null);
  useEffect(() => {
    const myChart = echarts.init(pieOneRef?.current);
    const option = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        bottom: 1,
        left: '10%',
        icon: 'circle',
        itemGap: 30,
        itemWidth: 20,
        itemHeight: 10,
      },
      grid: {
        bottom: 25,
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '60%'],
          hoverAnimation: false,
          // minAngle: 30,
          // itemStyle: {
          //   borderRadius: 10,
          //   borderWidth: 2,
          //   normal: {
          //     color: (params) => {
          //       const color = [
          //         '#E8D328',
          //         '#1981FF',
          //         '#2BCE98',
          //         '#F75000',
          //         '#1981FF',
          //         '#2BCE98',
          //       ];
          //       return color[params.dataIndex];
          //     },
          //   },
          // },
          label: {
            show: 'true',
            // color: '#424242',
            formatter: '{b}：{d}%',
            // alignTo: 'labelLine',
            // position: 'outer',
          },
          labelLine: {
            show: 'true',
            // length: 0,
            // length2: 10,
            // color: '#979797 ',
          },
          data: data,
        },
      ],
    };
    option && myChart.setOption(option);
    myChart.resize();
    window.addEventListener(
      'resize',
      function () {
        myChart.resize();
      },
      false,
    );
    return () => {
      window.removeEventListener('resize', function () {
        myChart.resize();
      });
    };
  }, [data]);
  return <Box ref={pieOneRef} sx={{ width: '100%', height: height }}></Box>;
};
